<template src="./index.html"></template>
<script>
	import minhead from '../../../../common/minHead/index.vue';
	import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
	import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
	import {
		getdata
	} from './data.js';
	import config from '../../../../../../configHttp.js';
	import uploadFile from '../../../../common/uploadFile/index.vue';
	import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
	import {
		querycell,
		manuscriptqueryCztdCell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd,
		sysYhsSm,
		queryCompanyShuibDict,
		savecztdCell,
		queryFcsCell,
		savefcsCell,
		fcTrack,
		tdTrack,
		fcsTemplate,
		tdsTemplate
	} from '../../../../../api/Draftgeneration.js';
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave,
		reportTrack
	} from '../../../../../api/bbmb.js';
	import {
		reportquerytrack
	} from '../../../../../api/xggj.js';
	import {
		zcfg_fycx,
		zcfg_fetch
	} from '../../../../../api/zcfg.js';
	import addzc from '../../../../common/addzc/index.vue';
	import seezc from '../../../../common/seezc/index.vue';
	import ConsolidatedStatement_I from './ConsolidatedStatement_I/index.vue';
	import {
		getdata as getdataI
	} from './ConsolidatedStatement_I/data.js';
	import ConsolidatedStatement_II from './ConsolidatedStatement_II/index.vue';
	import {
		getdata as getdataII
	} from './ConsolidatedStatement_II/data.js';
	import ConsolidatedStatement_III from './ConsolidatedStatement_III/index.vue';
	import {
		getdata as getdataIII
	} from './ConsolidatedStatement_III/data.js';
	import ConsolidatedStatement_VI from './ConsolidatedStatement_VI/index.vue';
	import {
		getdata as getdataVI
	} from './ConsolidatedStatement_VI/data.js';
	import ConsolidatedStatement_VII from './ConsolidatedStatement_VII/index.vue';
	import {
		getdata as getdataVII
	} from './ConsolidatedStatement_VII/data.js';
	import ConsolidatedStatement_VIII from './ConsolidatedStatement_VIII/index.vue';
	import {
		getdata as getdataVIII
	} from './ConsolidatedStatement_VIII/data.js';

	import ConsolidatedStatementII_II from './ConsolidatedStatementII_II/index.vue';
	import {
		getdata as getdataII_II
	} from './ConsolidatedStatementII_II/data.js';
	import ConsolidatedStatementI_II from './ConsolidatedStatementI_II/index.vue';
	import {
		getdata as getdataI_II
	} from './ConsolidatedStatementI_II/data.js';
	import ConsolidatedStatementII_III from './ConsolidatedStatementII_III/index.vue';
	import {
		getdata as getdataII_III
	} from './ConsolidatedStatementII_III/data.js';
	import ConsolidatedStatementI_III from './ConsolidatedStatementI_III/index.vue';
	import {
		getdata as getdataI_III
	} from './ConsolidatedStatementI_III/data.js';
	import ConsolidatedStatementI_I from './ConsolidatedStatementI_I/index.vue';
	import {
		getdata as getdataI_I
	} from './ConsolidatedStatementI_I/data.js';
	import ConsolidatedStatementII_I from './ConsolidatedStatementII_I/index.vue';
	import {
		getdata as getdataII_I
	} from './ConsolidatedStatementII_I/data.js';
	export default {
		name: '',
		components: {
			minhead,
			SalesTaxReportTree,
			SalesTaxReportbox,
			uploadFile,
			uploadFileplus,
			addzc,
			seezc,
			ConsolidatedStatement_I,
			ConsolidatedStatement_II,
			ConsolidatedStatement_III,
			ConsolidatedStatement_VI,
			ConsolidatedStatement_VII,
			ConsolidatedStatement_VIII,

			ConsolidatedStatementII_II,
			ConsolidatedStatementI_II,
			ConsolidatedStatementII_III,
			ConsolidatedStatementI_III,
			ConsolidatedStatementI_I,
			ConsolidatedStatementII_I
		},
		props: {
			seeNow: {
				type: Boolean,
				default: false
			},
			type: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			sbqj: {
				type: String,
				default: ''
			},
			showbox: {
				type: Boolean,
				default: false
			},
			mintext: {
				type: String,
				default: '填写'
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			suosq: {
				type: String,
				default: ''
			}
		},

		mounted() {
			if (this.toseeUpdate) {
				this.getShuibDetailList();
			} else {
				this.manuscriptqueryReportStep();
			}
		},
		data: function() {
			return {
				Changed: 0,
				treestate: '',
				statedata: [],
				treedata: [],
				choosetitleindex: '',
				formlist: getdata().formlist,
				headobj: {},
				choosecellCode: '',
				smtext: '',
				zcdata: [],
				searchlistzc: getdata().searchlistzc,
				headDatazc: getdata().headDatazc,
				pagination: getdata().pagination,
				seezcformlist: getdata().seezcformlist,
				formdatazc: getdata().formdatazc, //form表单数据
				tableDataII_I: [],
				//清空使用  因为是数据格式不一样选哟单独一个作用与清空的数组
				/*从价*/
				emptycj: ['ccxwfccj_2_x_1', 'ccxwfccj_2_x_2', 'ccxwfccj_2_x_3', 'ccxwfccj_2_x_4', 'ccxwfccj_2_x_5'],
				/*从组*/
				emptycz: ['ccxwfccz_2_x_1', 'ccxwfccz_2_x_2', 'ccxwfccz_2_x_3', 'ccxwfccz_2_x_4', 'ccxwfccz_2_x_5'],
				/*城镇*/
				emptychz: ['ccxwtd_2_x_1', 'ccxwtd_2_x_2', 'ccxwtd_2_x_3', 'ccxwtd_2_x_4', 'ccxwtd_2_x_5'],
				//
				tableData: [], //房产税
				ItableData: [], //房产税
				tableDataVII_II: [],
				tableDataVI_III: [], //房产税
				tableDataII_II: [], //印花税 - 财产性为税明细表
				tableDataII_III: [], //环保 - 财产性为税明细表
				tableDataI_II: [], //印花 - 纳税申报表
				tableDataI_III: [], //环保 - 纳税申报表
				tableDataIII: [], //印花税
				tableDataVI_I: [], //环保税
				tableDataI: [], //城镇土地 - 财产性为税明细表
				tableDataII: [], //城镇土地 - 纳税申报表
				tableDataVI_II: [], //城镇土地
				headDataVI: [],
				headDataVII: [],
				/*印花 - 财产性为税明细表*/
				HeadI: ['ccxwfc_1_x_1', 'ccxwfc_1_x_2', 'ccxwfc_1_x_3', 'ccxwfc_1_x_4', 'ccxwfc_1_x_5'],
				/*房产 - 纳税申报表*/
				Head: ['ccxwfc_0_x_1', 'ccxwfc_0_x_2', 'ccxwfc_0_x_3', 'ccxwfc_0_x_4', 'ccxwfc_0_x_5', 'ccxwfc_0_x_6',
					'ccxwfc_0_x_7', 'ccxwfc_0_x_8', 'ccxwfc_0_x_9', 'ccxwfc_0_x_10'
				],
				IIIHead: ['ccxwyh_3_x_1', 'ccxwyh_3_x_2', 'ccxwyh_3_x_3', 'ccxwyh_3_x_4', 'ccxwyh_3_x_5',
					'ccxwyh_3_x_6', 'ccxwyh_3_x_7', 'ccxwyh_3_x_8', 'ccxwyh_3_x_9',
					'ccxwyh_3_x_10', 'ccxwyh_3_x_11', 'ccxwyh_3_x_12', 'ccxwyh_3_x_13', 'ccxwyh_3_x_14',
					'ccxwyh_3_x_15', 'ccxwyh_3_x_16', 'ccxwyh_3_x_17', 'ccxwyh_3_x_18',
					'ccxwyh_3_x_19', 'ccxwyh_3_x_20', 'ccxwyh_3_x_21', 'ccxwyh_3_x_22', 'ccxwyh_3_x_23',
					'ccxwyh_3_x_24'
				],
				VIHead: ['ccxwhb_4_x_1', 'ccxwhb_4_x_2', 'ccxwhb_4_x_3', 'ccxwhb_4_x_4', 'ccxwhb_4_x_5',
					'ccxwhb_4_x_6',
					'ccxwhb_4_x_7', 'ccxwhb_4_x_8', 'ccxwhb_4_x_9', 'ccxwhb_4_x_10', 'ccxwhb_4_x_11',
					'ccxwhb_4_x_12', 'ccxwhb_4_x_13',
					'ccxwhb_4_x_14', 'ccxwhb_4_x_15', 'ccxwhb_4_x_16', 'ccxwhb_4_x_17', 'ccxwhb_4_x_18',
					'ccxwhb_4_x_19', 'ccxwhb_4_x_20',
					'ccxwhb_4_x_21', 'ccxwhb_4_x_22', 'ccxwhb_4_x_23', 'ccxwhb_4_x_24', 'ccxwhb_4_x_25',
					'ccxwhb_4_x_26', 'ccxwhb_4_x_27'
				],
				/*印花 - 财产性为税明细表*/
				II_IIHead: ['ccxwyh_1_x_1', 'ccxwyh_1_x_2', 'ccxwyh_1_x_3', 'ccxwyh_1_x_4', 'ccxwyh_1_x_5'],
				/*环保 - 财产性为税明细表*/
				II_IIIHead: ['ccxwhb_1_x_1', 'ccxwhb_1_x_2', 'ccxwhb_1_x_3', 'ccxwhb_1_x_4', 'ccxwhb_1_x_5',
					'ccxwhb_1_x_6', 'ccxwhb_1_x_7'
				],
				/*印花 - 纳税申报表*/
				I_IIHead: ['ccxwyh_0_x_1', 'ccxwyh_0_x_2', 'ccxwyh_0_x_3', 'ccxwyh_0_x_4', 'ccxwyh_0_x_5',
					'ccxwyh_0_x_6', 'ccxwyh_0_x_7', 'ccxwyh_0_x_8', 'ccxwyh_0_x_9', 'ccxwyh_0_x_10'
				],
				/*环保 - 纳税申报表*/
				I_IIIHead: ['ccxwhb_0_x_1', 'ccxwhb_0_x_2', 'ccxwhb_0_x_3', 'ccxwhb_0_x_4', 'ccxwhb_0_x_5',
					'ccxwhb_0_x_6', 'ccxwhb_0_x_7', 'ccxwhb_0_x_8', 'ccxwhb_0_x_9', 'ccxwhb_0_x_10'
				],
				/*城镇 - 纳税申报表*/
				IHead: ['ccxwtd_0_x_1', 'ccxwtd_0_x_2', 'ccxwtd_0_x_3', 'ccxwtd_0_x_4', 'ccxwtd_0_x_5', 'ccxwtd_0_x_6',
					'ccxwtd_0_x_7', 'ccxwtd_0_x_8', 'ccxwtd_0_x_9', 'ccxwtd_0_x_10'
				],
				/*城镇 - 财产性为税明细表*/
				IIHead: ['ccxwtd_1_x_1', 'ccxwtd_1_x_2', 'ccxwtd_1_x_3', 'ccxwtd_1_x_4', 'ccxwtd_1_x_5'],
				choosetable: '',
				chooseindex: '',
				choosecolum: '',
				dataarr: null, //data数据
				ccxwyh_0_x_7: [],
				ccxwyh_0_x_8: [],
				ccxwyh_0_x_10: [],
				ischaog: false
			};
		},
		created() {},
		methods: {
			Jishuan(res) {
				// console.log(res)
				// debugger
				this.ischaog = false;
				let cell=this.tableDataI_II[res.index][res.taxval].cellVal
				let nua = (parseFloat(this[res.taxval][res.index]) - parseFloat(cell==""?0:cell)).toFixed(2)
				nua = nua > 0 ? nua : Math.abs(nua)
				if (nua > 0.01) {
					this.tableDataI_II[res.index][res.taxval].cellVal = this[res.taxval][res.index];
					this.$message.error('改动值不能大于0.01');
					this.tableDataI_II = JSON.parse(JSON.stringify(this.tableDataI_II))
					this.ischaog = true;
				}
				this.ComputationalRelation(res)
				// parseFloat(e.cellVal).toFixed(2)
				// if (res.taxval == 'ccxwyh_0_x_7') {
				// 	let cell=this.tableDataI_II[res.index].ccxwyh_0_x_7.cellVal
				// 	let nua = (parseFloat(this.ccxwyh_0_x_7[res.index]) - parseFloat(cell==""?0:cell)).toFixed(2)
				// 	nua = nua > 0 ? nua : Math.abs(nua)
				// 	if (nua > 0.01) {
				// 		this.tableDataI_II[res.index].ccxwyh_0_x_7.cellVal = this.ccxwyh_0_x_7[res.index];
				// 		this.$message.error('改动值不能大于0.01');
				// 		this.tableDataI_II = JSON.parse(JSON.stringify(this.tableDataI_II))
				// 		this.ischaog = true;
				// 	}
				// } else if (res.taxval == 'ccxwyh_0_x_8') {
				// 	let cell=this.tableDataI_II[res.index].ccxwyh_0_x_8.cellVal
				// 	let nua = (parseFloat(this.ccxwyh_0_x_8[res.index]) - parseFloat(cell==""?0:cell)).toFixed(2)
				// 	nua = nua > 0 ? nua : Math.abs(nua)
				// 	if (nua > 0.01) {
				// 		this.tableDataI_II[res.index].ccxwyh_0_x_8.cellVal = this.ccxwyh_0_x_8[res.index];
				// 		this.$message.error('改动值不能大于0.01');
				// 		this.tableDataI_II = JSON.parse(JSON.stringify(this.tableDataI_II))
				// 		this.ischaog = true;
				// 	}
				// } else if (res.taxval == 'ccxwyh_0_x_10') {
				// 	let cell=this.tableDataI_II[res.index].ccxwyh_0_x_10.cellVal
				// 	let nua = (parseFloat(this.ccxwyh_0_x_10[res.index]) - parseFloat(cell==""?0:cell)).toFixed(2)
				// 	nua = nua > 0 ? nua : Math.abs(nua)
				// 	if (nua > 0.01) {
				// 		this.tableDataI_II[res.index].ccxwyh_0_x_10.cellVal = this.ccxwyh_0_x_10[res.index];
				// 		this.$message.error('改动值不能大于0.01');
				// 		this.tableDataI_II = JSON.parse(JSON.stringify(this.tableDataI_II))
				// 		this.ischaog = true;
				// 	}
				// }
			},
			ComputationalRelation(res) {
				if (res.taxval == 'ccxwyh_0_x_10') {
					this.tableDataI_II[res.index].ccxwyh_0_x_8.cellVal = (parseFloat(this.tableDataI_II[res.index]
							.ccxwyh_0_x_7.cellVal) - parseFloat(this.tableDataI_II[res.index].ccxwyh_0_x_10.cellVal))
						.toFixed(2)
				} else {
					this.tableDataI_II[res.index].ccxwyh_0_x_10.cellVal = (parseFloat(this.tableDataI_II[res.index]
							.ccxwyh_0_x_7.cellVal) - parseFloat(this.tableDataI_II[res.index].ccxwyh_0_x_8.cellVal))
						.toFixed(2)
				}
				let x_7 = 0;
				let x_8 = 0;
				let x_10 = 0;
				for (var i = 0; i < this.tableDataI_II.length; i++) {
					if (this.tableDataI_II.length != i + 1) {
						x_7=(parseFloat(x_7)+parseFloat(this.tableDataI_II[i].ccxwyh_0_x_7.cellVal)).toFixed(2)
						x_8 = (parseFloat(x_8)+parseFloat(this.tableDataI_II[i].ccxwyh_0_x_8.cellVal)).toFixed(2)
						x_10 = (parseFloat(x_10)+parseFloat(this.tableDataI_II[i].ccxwyh_0_x_10.cellVal)).toFixed(2)
					}
				}
				this.tableDataI_II[this.tableDataI_II.length - 1].ccxwyh_0_x_7.cellVal = x_7.toString()
				this.tableDataI_II[this.tableDataI_II.length - 1].ccxwyh_0_x_8.cellVal = x_8.toString()
				this.tableDataI_II[this.tableDataI_II.length - 1].ccxwyh_0_x_10.cellVal = x_10.toString()
				this.tableDataI_II = JSON.parse(JSON.stringify(this.tableDataI_II))
			},
			//政策点击预览
			zcsclick(id) {
				this.$refs.boxref.zcsclick(id);
			},
			//选中格子
			forhover(table, colum, index) {
				this.$refs.boxref.forhover(table, colum, index);
			},
			//获取选中格子
			getchoosecellCode(table, colum, index) {
				if (this.$emptyandnull(table)) {
					this.choosecellCode = '';
					return false;
				}
				this.choosetable = table;
				this.chooseindex = index;
				this.choosecolum = colum;

				this.choosecellCode = this[table][index][colum].cellCode;
				if (this.toseeUpdate) {
					this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
					this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
				} else {
					this.smtext = this[table][index][colum]['updateDesc'] || '';
				}
			},
			//更正说明
			forgengzheng(table, colum, index, smtext) {
				this[table][index][colum]['updateDesc'] = smtext;
			},
			//更正政策和说明
			forxzsm(table, colum, index, smtext, zcdata) {
				this[table][index][colum]['map'] = {
					desc: '',
					zcs: []
				};
				this[table][index][colum]['map']['desc'] = smtext;
				this[table][index][colum]['map']['zcs'] = zcdata;
			},
			//点击全部范围
			refreshhover() {
				this.$nextTick(() => {
					this.$refs.boxref.refreshhover();
				});
			},
			getShuibDetailList() {
				getShuibDetailList({
					shuizId: this.params.shuizId,
					id: this.params.shuibId
				}).then(res => {
					if (res.data.code == 1) {
						this.treedata = res.data.data;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			manuscriptqueryReportStep() {
				manuscriptqueryReportStep({
					id: this.params.id,
					sbbm: this.params.sbbm
				}).then(res => {
					if (res.data.code == 1) {
						this.statedata = res.data.data.statusHistory;
						this.treedata = res.data.data.detail;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			getchoosetitleindex(item) {
				this.choosetitleindex = item.shuibNameCode;
			},
			//表格隐藏显示和返回
			forback() {
				if (this.Changed > 0) {
					this.$showConfirm({
						message: "是否不保存当前修改?",
						title: "您还未保存",
					}).then((res) => {
						if (res == "confirm") {
							this.$emit('forback', true);
						} else {
							//取消
						}
					});
				} else {
					this.$emit('forback', true);
				}
			},
			changestate(e) {
				this.treestate = e;
			},
			//传给后端值处理
			filternums(data, filterlist) {
				var newlist = []
				filterlist.forEach(ytem => {
					let newval = data.map(item => {
						if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(
								item[ytem]) && item[ytem].cellVal != null) {
							return item[ytem]
						} else {
							return "x"
						}
					})
					newlist = [...newlist, ...newval].filter(gtem => gtem != 'x')
				})
				return newlist
			},
			//印花税重置
			refreshtableDataIII() {
				this.tableDataIII.forEach((item, index) => {
					this.IIIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
				this.tableDataII_II.forEach((item, index) => {
					this.II_IIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
				this.tableDataI_II.forEach((item, index) => {
					this.I_IIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
			},
			refreshtableDataI_I() {
				//房产税重置
				this.tableData.forEach((item, index) => {
					this.Head.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
				this.ItableData.forEach((item, index) => {
					this.HeadI.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].shuim = '';
							item[gtem].cellType = '';
						}
					});
				});
				if (this.tableDataVI_III.ccxwfccj) {
					this.tableDataVI_III.ccxwfccj.forEach((item, index) => {
						Object.keys(item.headBody).forEach(key => {
							item.headBody[key] = '';
						});
						item.cellBodys.forEach((item_one, index) => [
							this.emptycj.forEach(gtem => {
								if (item_one[gtem] && item_one[gtem].cellVal && item_one[gtem]
									.cellVal != '' && item_one[gtem].cellVal != '- -') {
									item_one[gtem].cellVal = '';
									item_one[gtem].cellType = '';
									item_one[gtem].shuim = '';
								}
							})
						]);
					});
					this.tableDataVI_III.ccxwfccz.forEach((item, index) => {
						Object.keys(item.headBody).forEach(key => {
							item.headBody[key] = '';
						});
						if (item.cellBodys.length != 0) {
							item.cellBodys.forEach((item_one, index) => [
								this.emptycz.forEach(gtem => {
									if (item_one[gtem] && item_one[gtem].cellVal && item_one[gtem]
										.cellVal != '' && item_one[gtem].cellVal != '- -') {
										item_one[gtem].cellVal = '';
										item_one[gtem].cellType = '';
										item[gtem].shuim = '';
									}
								})
							]);
						}
					});
				}
			},
			// 重置城镇税
			refreshtableDataVII() {
				if (this.tableDataVI_II) {
					this.tableDataVI_II.forEach(item => {
						Object.keys(item.headBody).forEach(key => {
							item.headBody[key] = '';
						});
						item.cellBodys.forEach((item_one, index) => {
							this.emptychz.forEach(gtem => {
								if (item_one[gtem] && item_one[gtem].cellVal && item_one[gtem]
									.cellVal != '' && item_one[gtem].cellVal != '- -') {
									item_one[gtem].cellVal = '';
									item_one[gtem].cellType = '';
									item[gtem].shuim = '';
								}
							});
						});
					});
				}
				this.tableDataI.forEach((item, index) => {
					this.IIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].shuim = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataII.forEach((item, index) => {
					this.IHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].shuim = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置环保税
			refreshtableDataVI() {
				this.tableDataVI_I.forEach((item, index) => {
					this.VIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].shuim = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataI_III.forEach((item, index) => {
					this.I_IIIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
				this.tableDataII_III.forEach((item, index) => {
					this.II_IIIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
				this.tableDataVII_II.forEach((item, index) => {
					this.VIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
							item[gtem].shuim = '';
						}
					});
				});
				// this.tableDataVI_II.forEach((item, index) => {
				// 	this.VIHead.forEach(gtem => {
				// 		if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem].cellVal != '- -') {
				// 			item[gtem].cellVal = ""
				// 			item[gtem].cellType = ""
				// 		}
				// 	})
				// })
			},
			//清空相关
			commanddcrefresh(e) {
				this.Changed++
				if (e == 'all') {
					Object.keys(this.headobj).map(key => (this.headobj[key] = ''));
					this.refreshtableDataIII();
					this.refreshtableDataVI();
					this.refreshtableDataI_I();
					this.refreshtableDataVII();
				}
			},
			inputblur(e) {
				if (
					parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this
						.choosecolum
					]['cellOldVal']).toFixed(2) &&
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
				) {
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
				}
			},
			//所有表格渲染s
			querycell(index) {
				//编辑格子查询
				if (this.type == 'update') {
					if (this.params.sbbm == 'cztds') {
						manuscriptqueryCztdCell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm
						}).then(res => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					} else if (this.params.sbbm == 'fcs') {
						queryFcsCell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm
						}).then(res => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					} else {
						querycell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm
						}).then(res => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					}
				}
				if (this.type == 'tosee') {
					if (this.seeNow) {
						if (this.params.sbbm == 'cztds') {
							manuscriptqueryCztdCell({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						} else if (this.params.sbbm == 'fcs') {
							queryFcsCell({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						} else {
							querycell({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						}
						return false;
					}
					if (this.toseeUpdate) {
						if (this.params.sbbm == 'cztds') {
							tdsTemplate({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						} else if (this.params.sbbm == 'fcs') {
							fcsTemplate({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						} else {
							querytemplatecell({
								shuibId: this.params.shuibId,
								id: this.params.id
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						}
					} else {
						if (this.params.sbbm == 'cztds') {
							tdTrack({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm,
								trackId: this.params.trackId
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						} else if (this.params.sbbm == 'fcs') {
							fcTrack({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm,
								trackId: this.params.trackId
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						} else {
							reportquerytrack({
								companyNo: this.params.companyNo, // 公司编号
								id: this.params.id, //报表id
								shuibId: this.params.shuibId, //税种id
								sbbm: this.params.sbbm,
								trackId: this.params.trackId
							}).then(res => {
								let dataarr = res.data.data;
								this.gettable(dataarr);
							});
						}

					}
				}
			},
			//通用方法
			fun(index, value, list) {
				queryCompanyShuibDict().then(res => {
					list.map(item => {
						Object.keys(item).map(key => {
							res.data.data.map(item1 => {
								if (key.substring(key.length, key.length - 1) == value) {
									if (item[key].cellVal == item1.shuibNameCode) {
										item[key].shuim = item1.reportName;
									}
								}
							});
						});
					});
				});
			},
			gettable(dataarr) {
				this.headDataVI = JSON.parse(JSON.stringify(getdataVI().headDataI))
				this.headobj = dataarr.head;
				this.headobj.regionalOrganizationName=this.headobj.regionalOrganizationName?this.headobj.regionalOrganizationName.split('|'):[]
				this.dataarr = dataarr;
				if (dataarr.ccxwyh_3) {
					dataarr.ccxwyh_3.forEach(item => {
						let objall = [];

						function sortnum(a, b) {
							return a.num - b.num;
						}

						function splitArray(array, size) {
							let data = [];
							for (let i = 0; i < array.length; i += size) {
								data.push({
									prop1: array.slice(i, i + size)[0],
									prop2: array.slice(i, i + size)[1],
									prop3: array.slice(i, i + size)[2]
								});
							}
							return data;
						}
						Object.keys(item).map(key => {
							if (key.substring(key.length - 2) > 19) {
								item[key].num = key.substring(key.length - 2);
								objall.push(item[key]);
							}
						});
						objall.sort(sortnum);
						item.tableDatadls = splitArray(objall, 3);
					});

					dataarr.ccxwyh_3.map((item, index) => {
						Object.keys(item).map(key => {
							dataarr.ccxwyh_3[index][`disabled${key}`] = true
							if (key.substring(key.length, key.length - 2) == 15) {
								if (dataarr.ccxwyh_3[index][key].cellVal == 0) {
									dataarr.ccxwyh_3[index][key].cellVal = '';
								}
							}
						});
					});
					sysYhsSm().then(res => {
						dataarr.ccxwyh_3.map(item => {
							res.data.data.map(item1 => {
								if (item1.zszm.length != 0) {
									item1.zszm.map(item2 => {
										if (item2.zszmDm == item.ccxwyh_3_x_7.cellVal) {
											item.ccxwyh_3_x_7.shuim = item2.zszmMc;
										}
									});
								}
								if (item.ccxwyh_3_x_6.cellVal == item1.zspmDm) {
									item.ccxwyh_3_x_6.shuim = item1.zspmMc;
								}
							});
						});
						this.tableDataIII = dataarr.ccxwyh_3;
					});
				}
				if (dataarr.ccxwfc_0) {
					var newtableData = dataarr.ccxwfc_0;
					var realtableData = newtableData;
					realtableData.forEach((item, index) => {
						this.Head.forEach(gtem => {
							item[gtem] = newtableData[index][gtem];
						});
					});
					sysYhsSm().then(res => {
						newtableData.map(item => {
							Object.keys(item).map(key => {
								res.data.data.map(item1 => {
									if (key.substring(key.length, key.length - 1) == 2) {
										if (item[key].cellVal == item1.zspmDm) {
											item[key].shuim = item1.zspmMc;
										}
									}
								});
							});
						});
					});
					this.fun(2, 1, newtableData);
					this.tableData = realtableData;
				}
				if (dataarr.ccxwfc_1) {
					var InewtableData = dataarr.ccxwfc_1;
					var IrealtableData = InewtableData;
					IrealtableData.forEach((item, index) => {
						if (InewtableData[index]) {
							this.HeadI.forEach(gtem => {
								item[gtem] = InewtableData[index][gtem];
							});
						}
					});
					this.ItableData = IrealtableData;
				}
				if (dataarr.ccxwfc_2) {
					//房产税
					if (dataarr.ccxwfc_2.ccxwfccz) {
						dataarr.ccxwfc_2.ccxwfccz.map(item => {
							let num = 3 - item.cellBodys.length
							if (num > 0) {
								for (let a = 0; a < num; a++) {
									item.cellBodys.push({
										"ccxwfccz_2_x_1": {
											"cellCode": `ccxwfccz_2_${item.cellBodys.length+1}_1_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"ccxwfccz_2_x_3": {
											"cellCode": `ccxwfccz_2_${item.cellBodys.length+1}_3_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"hanh": `${item.cellBodys.length+1}`,
										"ccxwfccz_2_x_2": {
											"cellCode": `ccxwfccz_2_${item.cellBodys.length+1}_2_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"ccxwfccz_2_x_4": {
											"cellCode": `ccxwfccz_2_${item.cellBodys.length+1}_5_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"ccxwfccz_2_x_5": {
											"cellCode": `ccxwfccz_2_${item.cellBodys.length+1}_4_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										}
									})
								}
							}
						})
					}
					if (dataarr.ccxwfc_2.ccxwfccj) {
						dataarr.ccxwfc_2.ccxwfccj.map(item => {
							let num = 3 - item.cellBodys.length
							if (num > 0) {
								for (let a = 0; a < num; a++) {
									item.cellBodys.push({
										"ccxwfccj_2_x_1": {
											"cellCode": `ccxwfccj_2_${item.cellBodys.length+1}_1_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"ccxwfccj_2_x_3": {
											"cellCode": `ccxwfccj_2_${item.cellBodys.length+1}_3_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"hanh": `${item.cellBodys.length+1}`,
										"ccxwfccj_2_x_2": {
											"cellCode": `ccxwfccj_2_${item.cellBodys.length+1}_2_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"ccxwfccj_2_x_4": {
											"cellCode": `ccxwfccj_2_${item.cellBodys.length+1}_5_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										},
										"ccxwfccj_2_x_5": {
											"cellCode": `ccxwfccj_2_${item.cellBodys.length+1}_4_m1`,
											"cellType": "0",
											"cellVal": "",
											'cellLaiy': '0',
										}
									})
								}
							}
						})
					}
					this.tableDataVI_III = dataarr.ccxwfc_2;
				}
				if (dataarr.ccxwtd_2) {
					dataarr.ccxwtd_2.forEach(item => {
						let num = 3 - item.cellBodys.length
						if (num > 0) {
							for (let a = 0; a < num; a++) {
								item.cellBodys.push({
									"ccxwtd_2_x_4": {
										"cellCode": `ccxwtd_2_${item.cellBodys.length+1}_4_m1`,
										"cellType": "0",
										"cellVal": "",
										'cellLaiy': '0',
									},
									"hanh": `${item.cellBodys.length+1}`,
									"ccxwtd_2_x_5": {
										"cellCode": `ccxwtd_2_${item.cellBodys.length+1}_5_m1`,
										"cellType": "0",
										"cellVal": "",
										'cellLaiy': '0',
									},
									"ccxwtd_2_x_2": {
										"cellCode": `ccxwtd_2_${item.cellBodys.length+1}_2_m1`,
										"cellType": "0",
										"cellVal": "",
										'cellLaiy': '0',
									},
									"ccxwtd_2_x_3": {
										"cellCode": `ccxwtd_2_${item.cellBodys.length+1}_3_m1`,
										"cellType": "0",
										"cellVal": "",
										'cellLaiy': '0',
									},
									"ccxwtd_2_x_1": {
										"cellCode": `ccxwtd_2_${item.cellBodys.length+1}_1_m1`,
										"cellType": "0",
										"cellVal": "",
										'cellLaiy': '0',
									}
								})
							}
						}
					})
					this.tableDataVI_II = dataarr.ccxwtd_2;
				}
				if (dataarr.ccxwtd_0) {
					//城镇土地税
					var newtableDataII = dataarr.ccxwtd_0;
					var realtableDataII = newtableDataII;
					realtableDataII.forEach((item, index) => {
						this.IHead.forEach(gtem => {
							item[gtem] = newtableDataII[index][gtem];
							// item[`disabled${gtem}`] = true;
						});
					});
					sysYhsSm().then(res => {
						newtableDataII.map(item => {
							Object.keys(item).map(key => {
								res.data.data.map(item1 => {
									if (key.substring(key.length, key.length - 1) == 2) {
										if (item[key].cellVal == item1.zspmDm) {
											item[key].shuim = item1.zspmMc;
										}
									}
								});
							});
						});
					});
					this.fun(2, 1, newtableDataII);
					this.tableDataII = realtableDataII;
				}
				if (dataarr.ccxwtd_1) {
					//城镇土地税
					var newtableDataI = dataarr.ccxwtd_1;
					var realtableDataI = newtableDataI;
					realtableDataI.forEach((item, index) => {
						if (newtableDataI[index]) {
							this.IIHead.forEach(gtem => {
								item[gtem] = newtableDataI[index][gtem];
								// item[`disabled${gtem}`] = true;
							});
						}
					});
					sysYhsSm().then(res => {
						realtableDataI.map(item => {
							Object.keys(item).map(key => {
								if (key.substring(key.length, key.length - 1) == 4) {
									if (item[key].cellVal == 0) {
										item[key].cellVal = '';
									}
								}
								res.data.data.map(item1 => {
									if (key.substring(key.length, key.length - 1) == 1) {
										if (item[key].cellVal == item1.zspmDm) {
											item[key].shuim = item1.zspmMc;
										}
									}
								});
							});
						});
					});
					this.tableDataI = realtableDataI;
				}
				if (dataarr.ccxwhb_0) {
					//环保税
					var newtableDataI_III = dataarr.ccxwhb_0;
					var realtableDataI_III = newtableDataI_III;
					realtableDataI_III.forEach((item, index) => {
						if (newtableDataI_III[index]) {
							this.I_IIIHead.forEach(gtem => {
								item[gtem] = newtableDataI_III[index][gtem];
							});
						}
					});
					this.fun(2, 1, realtableDataI_III);
					this.tableDataI_III = realtableDataI_III;
				}
				if (dataarr.ccxwhb_1) {
					//环保税
					var newtableDataII_III = dataarr.ccxwhb_1;
					var realtableDataII_III = newtableDataII_III;
					realtableDataII_III.forEach((item, index) => {
						if (newtableDataII_III[index]) {
							this.II_IIIHead.forEach(gtem => {
								item[gtem] = newtableDataII_III[index][gtem];
							});
						}
					});
					realtableDataII_III.map(item => {
						Object.keys(item).map(key => {
							if (key.substring(key.length, key.length - 1) == 6) {
								if (item[key].cellVal == 0) {
									item[key].cellVal = '';
								}
							}
						});
					});
					this.tableDataII_III = realtableDataII_III;
				}
				if (dataarr.ccxwyh_1) {
					//印花税
					var newtableDataII_II = dataarr.ccxwyh_1;
					var realtableDataII_II = newtableDataII_II;
					realtableDataII_II.forEach((item, index) => {
						if (newtableDataII_II[index]) {
							this.II_IIHead.forEach(gtem => {
								item[gtem] = newtableDataII_II[index][gtem];
							});
						}
					});
					sysYhsSm().then(res => {
						realtableDataII_II.map(item => {
							Object.keys(item).map(key => {
								if (key.substring(key.length, key.length - 1) == 4) {
									if (item[key].cellVal == 0) {
										item[key].cellVal = '';
									}
								}
								res.data.data.map(item1 => {
									if (key.substring(key.length, key.length - 1) == 1) {
										if (item[key].cellVal == item1.zspmDm) {
											item[key].shuim = item1.zspmMc;
										}
									}
								});
							});
						});
						this.tableDataII_II = realtableDataII_II;
					});
				}
				if (dataarr.ccxwyh_0) {
					//印花税
					var newtableDataI_II = dataarr.ccxwyh_0;
					var realtableDataI_II = newtableDataI_II;
					realtableDataI_II.forEach((item, index) => {
						if (newtableDataII_II[index]) {
							this.I_IIHead.forEach(gtem => {
								item[gtem] = newtableDataI_II[index][gtem];
							});
						}
					});

					this.fun(2, 1, realtableDataI_II);
					sysYhsSm().then(res => {
						realtableDataI_II.map(item => {
							Object.keys(item).map(key => {
								res.data.data.map(item1 => {
									if (key.substring(key.length, key.length - 1) == 2) {
										if (item[key].cellVal == item1.zspmDm) {
											item[key].shuim = item1.zspmMc;
										}
									}
								});
							});
						});
						this.tableDataI_II = realtableDataI_II;
						this.ccxwyh_0_x_7 = this.tableDataI_II.map(v => v.ccxwyh_0_x_7.cellVal)
						this.ccxwyh_0_x_8 = this.tableDataI_II.map(v => v.ccxwyh_0_x_8.cellVal)
						this.ccxwyh_0_x_10 = this.tableDataI_II.map(v => v.ccxwyh_0_x_10.cellVal)
					});
				}
				if (dataarr.ccxwhb_4) {
					this.VIHead = []
					var newtableDataVI_I = dataarr.ccxwhb_4 ? dataarr.ccxwhb_4.filter((item, index) => item.hanh < 25) :
				[];
					var realtableDataVI_I = getdataVI().tableDataI;
					let list = Object.keys(newtableDataVI_I[0])
					list.map((key, index) => {
						if (index != list.length - 1 || index == 0) {
							this.VIHead.push(`ccxwhb_4_x_${index+1}`)

						}
					})
					realtableDataVI_I.forEach((item, index) => {
						if (newtableDataVI_I[index]) {
							this.VIHead.forEach(gtem => {
								if (newtableDataVI_I[index][gtem]) {
									item[gtem] = newtableDataVI_I[index][gtem];
								} else {
									item[gtem] = {
										[gtem]: {}
									};
								}
							});
						}
					});
					this.VIHead.map(key => {
						if (key != "hanh") {
							this.headDataVI.push({
								custom: true,
								prop: key,
								title: "",
								width: "200px",
							})
						}
					})
					this.tableDataVI_I = realtableDataVI_I;
					var newtableDataVI_II = dataarr.ccxwhb_4 ? dataarr.ccxwhb_4.filter((item, index) => item.hanh > 24) :
					[];
					var realtableDataVI_II = getdataVI().tableDataII;
					realtableDataVI_II.forEach((item, index) => {
						if (newtableDataVI_II[index]) {
							this.VIHead.forEach(gtem => {
								if (newtableDataVI_II[index][gtem]) {
									item[gtem] = newtableDataVI_II[index][gtem];
									item[gtem][`disabled${gtem}`] = true;
								} else {
									item[gtem] = {
										cellCode: ''
									};
									item[gtem][`disabled${gtem}`] = true;
								}
							});
						}
					});
					this.tableDataVII_II = realtableDataVI_II

				}
			},
			forsave() {
				if (this.ischaog) {
					this.ischaog = false
					return
				}
				let newarr = [];
				if (this.params.sbbm == 'cztds' || this.params.sbbm == 'fcs') {
					newarr = this.dataarr;
				} else {
					newarr = [
						...this.filternums(this.tableDataVI_I, this.VIHead),
						...this.filternums(this.tableDataVII_II, this.VIHead),
						...this.filternums(this.tableDataI_II, this.I_IIHead),
						...this.filternums(this.tableDataII_II, this.II_IIHead),
						...this.filternums(this.tableDataII_III, this.II_IIIHead),
						...this.filternums(this.tableDataI_III, this.I_IIIHead),
						...this.filternums(this.tableDataIII, this.IIIHead),
					];
				}
				let params = {
					companyNo: this.params.companyNo,
					id: this.params.id,
					sbbm: this.params.sbbm,
					// "head": this.headobj,
					checkFlag: true
				};
				
				if (this.params.sbbm == 'cztds') {
					params.data = newarr;
					params.data.head.regionalOrganizationName=params.data.head.regionalOrganizationName?params.data.head.regionalOrganizationName.join('|'):''
					savecztdCell(params).then(res => {
						if (res.data.code == 1) {
							this.querycell();
							this.$message.success(res.data.msg);
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (this.params.sbbm == 'fcs') {
					params.data = newarr;
					params.data.head.regionalOrganizationName=params.data.head.regionalOrganizationName?params.data.head.regionalOrganizationName.join('|'):''
					savefcsCell(params).then(res => {
						if (res.data.code == 1) {
							this.querycell();
							this.$message.success(res.data.msg);
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					params.head = this.headobj;
					params.cells = newarr;
					params.head.regionalOrganizationName=params.head.regionalOrganizationName?params.head.regionalOrganizationName.join('|'):''
					writesave(params).then(res => {
						if (res.data.code == 1) {
							this.querycell();
							this.$message.success(res.data.msg);
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>